<app-header></app-header>
<app-error-notify [issuccess]="true"></app-error-notify>
<div class="main-container full-view menu-split">
    <app-sidemenu ></app-sidemenu>
    <app-goback class="back-position"></app-goback>
    <router-outlet></router-outlet>
</div>
